import { DataTable, useColumns } from "@/components/data-table";
import { useFilters } from "@/components/filters";
import { ListPage } from "@/components/list-page";
import { useOpenModal } from "@/components/modal";
import { useGetAllPaisesQuery } from "@/features/auxiliar/pais/api/get-all-paises";
import { formatDate, formatString } from "@/shared/formats";

export default function PaisesPage() {
    const openModal = useOpenModal();

    const filterData = useFilters({
        filters: [
            { type: "string", label: "Nombre", name: "nombre" },
            { type: "string", label: "Código", name: "codigo" },
            { type: "string", label: "Nacionalidad", name: "nacionalidad" },
            { type: "pagination" }
        ]
    })

    const fetchData = useGetAllPaisesQuery(filterData.filterData);

    const columnData = useColumns({
        columns: [
        {key: "Nombre", header:"Nombre", render: row => formatString(row.nombre)},
        {key: "Codigo", header:"Código", render: row => formatString(row.codigo)},
        {key: "Nacionalidad", header:"Nacionalidad", render: row => formatString(row.nacionalidad)},
        {key: "CreadoPor", header:"Creado Por", render: row => formatString(row.creadoPor)},
        {key: "FechaCreacion", header:"Fecha de Creación", render: row => formatDate(row.fechaCreacion)},
        {key: "ModificadoPor", header:"Modificado Por", render: row => formatString(row.modificadoPor)},
        {key: "FechaModificacion", header:"Fecha de Modificación", render: row => formatDate(row.fechaModificacion)},
        ],
        key: "paises"
    })

    return <ListPage>
        <ListPage.Header>
            <ListPage.Header.Actions title="Países">
                <ListPage.Header.Actions.FilterButton />
                <ListPage.Header.Actions.ColumnButton columnData={columnData} />
                <ListPage.Header.Actions.Divider />
                <ListPage.Header.Actions.ExportButton onClick={() => openModal("print")}>
                    <ListPage.Header.Actions.ExportButton.Print onClick={() => openModal("print")} />
                    <ListPage.Header.Actions.ExportButton.Csv onClick={() => openModal("csv")} />
                    <ListPage.Header.Actions.ExportButton.Xlsx onClick={() => openModal("xlsx")} />
                </ListPage.Header.Actions.ExportButton>
            </ListPage.Header.Actions>
            <ListPage.Header.Filters filterData={filterData} />
        </ListPage.Header>
        <DataTable flex={1}>
            <DataTable.Content
                rows={fetchData.data?.result}
                columns={columnData.columns}
                fit="flex"
                loading={fetchData.isFetching}
                error={fetchData.error}
            />
            <DataTable.Pagination filterData={filterData} queryResult={fetchData} />
        </DataTable>
    </ListPage>;
}